import React, { createContext, useContext, useState, ReactNode } from 'react';
import { TemplateType } from '@admiin-com/ds-graphql';

interface DocumentEditorContextType {
  includeLetterhead: boolean;
  setIncludeLetterhead: (value: boolean) => void;
  templateType?: TemplateType;
}

const DocumentEditorContext = createContext<
  DocumentEditorContextType | undefined
>(undefined);

interface DocumentEditorProviderProps {
  children: ReactNode;
  initialIncludeLetterhead?: boolean;
  onLetterheadChange?: (includeLetterhead: boolean) => void;
  templateType?: TemplateType;
}

export const DocumentEditorProvider: React.FC<DocumentEditorProviderProps> = ({
  children,
  initialIncludeLetterhead = true,
  onLetterheadChange,
  templateType,
}) => {
  const [includeLetterhead, setIncludeLetterhead] = useState(
    initialIncludeLetterhead
  );

  const handleLetterheadChange = (value: boolean) => {
    setIncludeLetterhead(value);
    onLetterheadChange?.(value);
  };

  return (
    <DocumentEditorContext.Provider
      value={{
        includeLetterhead,
        setIncludeLetterhead: handleLetterheadChange,
        templateType,
      }}
    >
      {children}
    </DocumentEditorContext.Provider>
  );
};

export const useDocumentEditorContext = () => {
  const context = useContext(DocumentEditorContext);
  if (!context) {
    throw new Error(
      'useDocumentEditorContext must be used within DocumentEditorProvider'
    );
  }
  return context;
};
